import PropTypes from 'prop-types';

import { legacyTheme } from '@prose-ui/legacy';
import config from 'Config';
import { withStyles } from 'legacyStyles';

import { Button } from 'Components/LegacyButton';
import Title from 'Components/Title';
import { Typography } from 'Components/Typography';

import bottles from 'assets/images/products_consultation.jpg';

import BaseScene from './BaseScene';

const styles = {
  root: {
    flexDirection: 'row',
    justifyContent: 'center',
    [legacyTheme.breakpoints.match('sm')]: {
      padding: 0,
    },
  },
  content: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '18px',
    maxWidth: 600,
    [legacyTheme.breakpoints.match('sm')]: {
      width: '100%',
    },
  },
  avatar: {
    borderRadius: '50%',
    width: '30%',
    maxWidth: 200,
  },
  image: {
    width: '50%',
    maxWidth: 600,
    [legacyTheme.breakpoints.match('sm')]: {
      display: 'none',
    },
  },
};

const StylistHero = ({ avatar, classes, name, onClick }) => (
  <BaseScene classes={{ content: classes.root }}>
    <img alt="bottles" className={classes?.image} src={bottles.src} />
    <div className={classes.content}>
      <img alt={name} className={classes?.avatar} src={avatar.src} />
      <Title>{name} for Prose</Title>
      <Typography align="center" color="grey" variant="p1">
        Thanks for checking out Prose! I’m excited for you to get started on your personal
        consultation. You’ll answer a series of questions so Prose can properly formulate your
        custom products. It should only take about 5 minutes to complete and your products will be
        delivered within {config.shippingDelay} days.
      </Typography>
      <Button onClick={onClick} variant="vert">
        Begin
      </Button>
    </div>
  </BaseScene>
);

StylistHero.propTypes = {
  avatar: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string),
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

StylistHero.defaultProps = {
  classes: null,
};

export default withStyles(StylistHero, styles);
